var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.currentPage && _vm.pageNumber !== _vm.dots)?_c('NuxtLink',{class:[
    'pagination-btn',
    _vm.disabled && 'pagination-btn--disabled',
    _vm.isActive && 'pagination-btn--active',
  ],attrs:{"to":{
    path: _vm.$route.path,
    query:
      _vm.pageNumber === 1
        ? { ..._vm.$route.query, page: undefined }
        : { ..._vm.$route.query, page: _vm.pageNumber },
  }}},[_vm._t("default")],2):_c('span',{class:[
    'pagination-btn',
    _vm.disabled && 'pagination-btn--disabled',
    _vm.isActive && 'pagination-btn--active',
  ]},[_vm._v("\n  "+_vm._s(_vm.pageNumber)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }